import { TableCell } from "pdfmake/interfaces";
import { PDFExportOptions } from "../../shared/pdf-export/pdf-export.model";
import { NoteColumn, NoteColumnField, NotesTableDataRow } from "../notes-table/notes-table.model";

interface NoteExportColumn {
	field: NoteColumnField;
	header: string;
}

class NoteExportColumn {
	static defaultColumns: NoteExportColumn[] = [
		{ field: 'timeframe', header: 'Timeframe' },
		{ field: 'turnover', header: 'TN' },
		{ field: 'createdBy', header: 'Source' },
		{ field: 'note', header: 'Note' },
		{ field: 'tags', header: 'Tags' },
		{ field: 'updated', header: 'Updated At' },
		{ field: 'updatedBy', header: 'Updated By' }
	]
}

export class NoteExportData {
	noteColIndex: number;

	get noteIsLastColumn() {
		return this.noteColIndex == this.columns.length - 1;
	}

	constructor(
		public notes: NotesTableDataRow[],
		public headerMessage: string,
		public queryParams: { [queryParam: string]: string },
		public pdfExportOptions: PDFExportOptions,
		public columns: NoteExportColumn[] = NoteExportColumn.defaultColumns
	) {
		this.noteColIndex = columns.findIndex(x => x.field == 'note');
	}

	getCellArray(): TableCell[]  {
		return Array(this.columns.length).fill('');
	}

	static getExportColumns(noteColumns: NoteColumn[]): NoteExportColumn[] {
		return [
			{ field: 'timeframe', header: 'Timeframe' },
			{ field: 'turnover', header: 'TN' },
			...noteColumns
				.filter(c => c.show)
				.map(c => ({ field: c.field, header: c.header }))
		];
	}
}